import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const { Types: LegalTypes, Creators: LegalActions } = createActions(
  {
    fetchTermsAndConditions: null,
    setTermsAndConditions: ['content'],
    fetchPrivacyPolicy: null,
    setPrivacyPolicy: ['content'],
    fetchCookiesPolicy: null,
    setCookiesPolicy: ['content'],
  },
  { prefix: 'LEGAL_' }
);

export const INITIAL_STATE = Immutable({
  termsAndConditions: null,
  privacyPolicy: null,
  cookiesPolicy: null,
});

const handleSetTermsAndConditionsContent = (state, { content }) => state.set('termsAndConditions', content);
const handleSetPrivacyPolicyContent = (state, { content }) => state.set('privacyPolicy', content);
const handleSetCookiesPolicyContent = (state, { content }) => state.set('cookiesPolicy', content);

export const reducer = createReducer(INITIAL_STATE, {
  [LegalTypes.SET_TERMS_AND_CONDITIONS]: handleSetTermsAndConditionsContent,
  [LegalTypes.SET_PRIVACY_POLICY]: handleSetPrivacyPolicyContent,
  [LegalTypes.SET_COOKIES_POLICY]: handleSetCookiesPolicyContent,
});
